<template>
    <div>
        <div id="Dashboard" class="container is-fluid">
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />

            <!-- Header -->
            <HeroContainer title="Part History Dashboard" />

            <section id="filters" class="filters-section">
                <div class="card shadow-sm filters-card">
                    <div class="card-content filters-body">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Part</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div>
                                        <input
                                            type="text"
                                            class="input"
                                            placeholder="Part (required)"
                                            v-model="part_number"
                                            @input="part_number = $event.target.value.toUpperCase()"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Period</label>
                            </div>
                            <div class="field-body">
                                <div class="field has-addons">
                                    <p class="control">
                                        <span class="select">
                                            <select
                                                id="date_range"
                                                v-model="date_range"
                                                @change="change_date(date_range)"
                                            >
                                                <option
                                                    disabled
                                                    hidden
                                                    value=""
                                                    style="color: grey"
                                                >
                                                    Date Presets
                                                </option>
                                                <option
                                                    v-for="(selectOption, index) in selectOptions"
                                                    :value="selectOption.value"
                                                    :key="index"
                                                >
                                                    {{ selectOption.label }}
                                                </option>
                                                <option disabled hidden value="custom">
                                                    Custom
                                                </option>
                                            </select>
                                        </span>
                                    </p>
                                    <p class="control is-expanded">
                                        <VueDatePicker
                                            v-model="range"
                                            :enable-time-picker="false"
                                            range
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="buttons is-right filters-actions">
                            <button @click="reset" class="button is-small is-white">Reset</button>
                            <div class="filter-action">
                                <button
                                    @click="ajax_get_dashboard"
                                    class="button is-info"
                                    :disabled="isSearching"
                                >
                                    Filter
                                </button>
                                <span
                                    v-if="isSearching"
                                    class="loading-icon"
                                    aria-live="polite"
                                    aria-label="Loading part history"
                                >
                                    <i class="material-icons rotating">.</i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="part_history_textron" v-if="this.textronData.length > 0">
                <div class="title_div">
                    <span class="site">Textron</span>
                </div>
                <PartHistoryTable
                    :key="table_key"
                    :rows="textronData"
                    :columns="dashBoardPartHistoryDiscountColumnsHeader"
                    :initial-sort="{ field: 'orig_created', direction: 'desc' }"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="$emit('download-csv', [textronData, 'PartHistoryTextron', null])"
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section id="part_history_textron_defense" v-if="textronDefenseData.length > 0">
                <div class="title_div">
                    <span class="site">Textron Defense</span>
                </div>
                <PartHistoryTable
                    :key="table_key"
                    :rows="textronDefenseData"
                    :columns="dashBoardPartHistoryDiscountColumnsHeader"
                    :initial-sort="{ field: 'time_updated', direction: 'desc' }"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="
                            $emit('download-csv', [
                                textronDefenseData,
                                'PartHistoryTextronDefense',
                                null,
                            ])
                        "
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section id="part_history_boeing" v-if="boeingData.length > 0">
                <div class="title_div">
                    <span class="site">Boeing</span>
                </div>
                <PartHistoryTable
                    :key="table_key"
                    :rows="boeingData"
                    :columns="dashBoardPartHistoryColumnsHeader"
                    :initial-sort="{ field: 'orig_created', direction: 'desc' }"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="$emit('download-csv', [boeingData, 'PartHistoryBoeing', null])"
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section id="part_history_ils" v-if="ilsData.length > 0">
                <div class="title_div">
                    <span class="site">ILS</span>
                </div>
                <PartHistoryTable
                    :key="table_key"
                    :rows="boeingData"
                    :columns="dashBoardPartHistoryColumnsHeader"
                    :initial-sort="{ field: 'orig_created', direction: 'desc' }"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="$emit('download-csv', [IlsData, 'PartHistoryIls', null])"
                    >
                        Download CSV
                    </button>
                </div>
            </section>

            <section id="part_history_partsbase" v-if="partsbaseData.length > 0">
                <div class="title_div">
                    <span class="site">PartsBase</span>
                </div>
                <PartHistoryTable
                    :key="table_key"
                    :rows="boeingData"
                    :columns="dashBoardPartHistoryColumnsHeader"
                    :initial-sort="{ field: 'orig_created', direction: 'desc' }"
                />
                <div class="buttons is-right">
                    <button
                        class="button is-info"
                        style="margin: 0.5em 0 0 0"
                        @click="
                            $emit('download-csv', [partsbaseData, 'PartHistoryPartsBase', null])
                        "
                    >
                        Download CSV
                    </button>
                </div>
            </section>
        </div>
    </div>
</template>

<style scoped>
    .title_div {
        margin-top: 1.5em;
    }

    .site {
        font-size: 2em;
    }

    .filters-section {
        display: flex;
        justify-content: center;
    }

    .filters-card {
        width: 100%;
        max-width: 720px;
        margin: 0 auto 1.5em;
    }

    .filters-body {
        display: flex;
        flex-direction: column;
        gap: 0.75em;
    }

    .filters-actions {
        margin-top: 0.5em;
        gap: 0.75em;
    }

    .filter-action {
        display: flex;
        align-items: center;
        gap: 0.5em;
    }

    .loading-icon {
        display: flex;
        align-items: center;
        color: #3273dc;
    }

    .rotating {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>

<script>
    import moment from 'moment'
    import VueDatePicker from '@vuepic/vue-datepicker'
    import { getDates } from '@/helpers/dates.js'
    import HeroContainer from '@/components/shared/HeroContainer.vue'
    import PartHistoryTable from '@/components/shared/PartHistoryTable.vue'

    import dashBoardPartHistoryColumnsHeader from '@/data/DashBoardPartHistoryColumnsHeader'
    import dashBoardPartHistoryDiscountColumnsHeader from '@/data/DashBoardPartHistoryDiscountColumnsHeader'
    import { mapStores, mapWritableState } from 'pinia'
    import { useDropdownsStore } from '@/stores/dropdownsStore'
    import { usePartHistoryStore } from '@/stores/partHistoryStore'

    export default {
        name: 'DashboardPartHistory',
        components: {
            VueDatePicker,
            HeroContainer,
            PartHistoryTable,
        },
        computed: {
            ...mapStores(useDropdownsStore, usePartHistoryStore),
            ...mapWritableState(usePartHistoryStore, {
                table_key: 'table_key',
                figureKey: 'figureKey',
                part_number: 'part_number',
                date_range: 'date_range',
                range: 'range',
                queryDataRaw: 'queryDataRaw',
            }),
            is_paged: function () {
                if (this.queryData.length <= 10) {
                    return false
                } else {
                    return true
                }
            },
            customer_items() {
                return this.dropdownsStore.customer
            },
            vendor_items() {
                return this.dropdownsStore.vendor
            },
            user_items() {
                return this.dropdownsStore.user
            },
            queryData() {
                let raw_query = [...this.queryDataRaw]
                return raw_query
            },
            isSearching() {
                return this.searchStore.ajax_searching > 0
            },
            textronData() {
                let filtered = []
                let queryData = this.queryData
                for (let row of queryData) {
                    if (row.site == 'Textron') {
                        filtered.push(row)
                    }
                }
                return filtered
            },
            textronDefenseData() {
                let filtered = []
                let queryData = this.queryData
                for (let row of queryData) {
                    if (row.site == 'Textron Defense') {
                        filtered.push(row)
                    }
                }
                return filtered
            },
            boeingData() {
                let filtered = []
                let queryData = this.queryData
                for (let row of queryData) {
                    if (row.site == 'Boeing') {
                        filtered.push(row)
                    }
                }
                return filtered
            },
            ilsData() {
                let filtered = []
                for (let row of this.queryData) {
                    if (row.site == 'ILS') {
                        filtered.push(row)
                    }
                }
                return filtered
            },
            partsbaseData() {
                let filtered = []
                for (let row of this.queryData) {
                    if (row.site == 'PartsBase') {
                        filtered.push(row)
                    }
                }
                return filtered
            },
        },
        data: function () {
            return {
                dashBoardPartHistoryColumnsHeader,
                dashBoardPartHistoryDiscountColumnsHeader,
                selectOptions: [
                    { value: 'today', label: 'Today' },
                    { value: 'week', label: 'Week' },
                    { value: 'this_month', label: 'This Month' },
                    { value: 'prev_month', label: 'Prev Month' },
                    { value: 'this_quarter', label: 'This Quarter' },
                    { value: 'prev_quarter', label: 'Prev Quarter' },
                    { value: 'this_year', label: 'This Year' },
                    { value: 'prev_year', label: 'Prev Year' },
                    { value: 'all', label: 'All' },
                ],
                moment: require('moment'),
            }
        },
        watch: {
            queryData: function () {
                // Change key to force the component to re-render
                // otherwise it will have height=0
                this.partHistoryStore.addToTableKeyPartHistory(1)
            },
            plotData: function () {
                // Change key to force the component to re-render
                // otherwise it will have height=0
                this.partHistoryStore.addToFigureKeyPartHistory(1)
            },
        },
        methods: {
            getDates,

            reset() {
                this.partHistoryStore.setResetPartHistory()
            },
            change_date(date_range) {
                let range = this.getDates(date_range)
                if (range) {
                    this.partHistoryStore.setRangePartHistory(range)
                }
            },
            set_searching(is_searching) {
                this.searchStore.set_ajax_searching(is_searching)
            },
            filter_records() {
                this.ajax_get_dashboard(this.filter_customer, this.filter_user)
            },
            async ajax_get_dashboard() {
                this.partHistoryStore.setQueryDataRawPartHistory([])
                this.period_last_filtered = this.period
                const part_number = this.part_number.trim()
                const begin_date = moment.utc(this.range[0]).format('YYYY-MM-DD')
                const end_date = moment.utc(this.range[1]).endOf('day').format('YYYY-MM-DD')
                this.set_searching(true)
                try {
                    await this.partHistoryStore.fetchPartHistory({
                        part_number,
                        begin_date,
                        end_date,
                    })
                } catch (e) {
                    console.error(JSON.stringify(e?.message || e))
                } finally {
                    this.set_searching(false)
                }
            },
        },
    }
</script>
